import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "password", "errorMessage", "submitButton", "amount"]

  handleSuccess(event) {
    const [data, _status, _xhr] = event.detail

    if (data.success) {
      // Close modal and reload page to show updated status
      const modal = bootstrap.Modal.getInstance(document.getElementById('ajaxModal'))
      modal.hide()
      window.location.reload()
    } else {
      this.showError(data.error || 'An error occurred')
    }
  }

  handleError(event) {
    const [_data, _status, xhr] = event.detail
    let errorMessage = 'An error occurred'

    try {
      const response = JSON.parse(xhr.response)
      errorMessage = response.error || errorMessage
    } catch (e) {
      // Use default error message
    }

    this.showError(errorMessage)
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove('d-none')
    this.passwordTarget.value = ''
    this.passwordTarget.focus()
  }
}
